
export default {
  name: "NFCPopup",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type:Number,
      default: 0, // 0 是准备读取， 1是成功 -1是失败
    },
    msg: {
      type: Object,
      default: () => {
        return {
          title: "Read to Read",
          message: "Place your product in the NFC area"
        };
      }
    }
  },
  methods: {
    input() {
      this.$emit("input");
    }
  }
};
